/* eslint-disable max-len */
import React, { useState } from 'react';
import {
  useTheme, Box, Button, Typography,
} from '@material-ui/core';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import tz from 'dayjs/plugin/timezone';
import dayjsduration from 'dayjs/plugin/duration';
import dynamic from 'next/dynamic';
import ShadowBox from 'common/components/shadow_box/ShadowBox';
import TextBox from 'common/components/TextBox';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import LightBulbHint from 'common/components/LightBulbHint';
import { useLayoutState } from 'components/shared/Layout';
import { withTranslation, i18n } from 'config/i18n';
import VehiclePriceSummary from 'views/vehicle_page/components/VehiclePriceSummary';
import getLocalizedUrl from 'utils/getLocalizedUrl';
import { InfoRounded } from '@material-ui/icons';

const Map = dynamic(() => import('components/shared/CircleMap'), {
  ssr: false,
});
const VehicleSummary = dynamic(() => import('views/vehicle_page/components/VehicleSummary'));

dayjs.extend(dayjsduration);
dayjs.extend(utc);
dayjs.extend(tz);
const VehiclePageQuote = (props) => {
  const {
    bookingData,
    location,
    vehicleDetails,
    price,
    hasInsurance,
    t,
    spinner,
    vehicleReservations,
    formattedMiles,
    formattedIncrease,
    errors,
    availabilityData,
    setAvailabilityData,
    calendarData,
    setCalendarData,
    checkAvailability,
    handleMonthChange,
    pricingOption,
    handleHourlyPackageChange,
    isHourlyMode,
    setIsHourlyMode,
    enableCheckout,
    setEnableCheckout,
    hourlyPrice,
    id,
  } = props;
  const theme = useTheme();
  const { layoutState } = useLayoutState();

  const [showMap, setShowMap] = useState(!layoutState.isCrawler);

  const checkDuration = () => {
    const pickup = dayjs(`${bookingData.pickup_date} ${bookingData.pickup_time_slot}`);
    const duration = dayjs.duration(pickup.diff(dayjs()));
    return duration.as('hours') > 24;
  };
  const circleLoaction = {
    circleCenter: {
      lng: +location.lng,
      lat: +location.lat,
    },
  };
  const freeCancelationDate = dayjs(
    `${bookingData.pickup_date} ${bookingData.pickup_time_slot}`,
  ).subtract(24, 'hours');
  const handleShowMapClick = () => {
    setShowMap(true);
  };
  return (
    <>
      <Box id={id}>
        {!vehicleDetails?.booking_disabled && (
          <ShadowBox>
            <VehiclePriceSummary
              bookingData={bookingData}
              price={price}
              location={location}
              pricingOption={pricingOption}
              hourlyPrice={hourlyPrice}
            />
            {!layoutState.isCrawler && (
              <VehicleSummary
                bookingData={bookingData}
                price={price}
                location={location}
                errors={errors}
                spinner={spinner}
                vehicleDetails={vehicleDetails}
                availabilityData={availabilityData}
                setAvailabilityData={setAvailabilityData}
                calendarData={calendarData}
                setCalendarData={setCalendarData}
                checkAvailability={checkAvailability}
                handleMonthChange={handleMonthChange}
                pricingOption={pricingOption}
                handleHourlyPackageChange={handleHourlyPackageChange}
                isHourlyMode={isHourlyMode}
                setIsHourlyMode={setIsHourlyMode}
                setEnableCheckout={setEnableCheckout}
                enableCheckout={enableCheckout}
                vehicleReservations={vehicleReservations}
                hourlyPrice={hourlyPrice}
              />
            )}
          </ShadowBox>
        )}

        {!vehicleDetails?.booking_disabled && (
          <>
            <Box my={2.5}>
              <TextBox title={formattedMiles} description={formattedIncrease} />
            </Box>

            <Box mb={2.5}>
              <TextBox
                icon={<VerifiedUserIcon />}
                iconColor={theme.palette.info.main}
                title={t('fe_es_vehicle_page:cancellation_policy')}
                description={`
                  ${
                    checkDuration()
                      ? `${t('fe_es_vehicle_page:full_refund', {
                        date: dayjs(freeCancelationDate).format('MMM D, YYYY, h:mm A '),
                      })}`
                      : ''
                  }`}
                btnText={t('fe_es_vehicle_page:view_full_details')}
                btnPath={getLocalizedUrl('/cancellation-terms-policies', i18n.language)}
              >
                <Box display="flex" mt={1}>
                  <Box color="info.main">
                    <InfoRounded />
                  </Box>
                  <Box pl={1} color="secondary.light">
                    <Typography variant="body2">
                      {t('fe_es_vehicle_page:cancellation_note')}
                    </Typography>
                  </Box>
                </Box>
              </TextBox>
            </Box>

            {hasInsurance && (
              <Box mb={2.5}>
                <TextBox
                  title={t('fe_es_vehicle_page:insurace_protection')}
                  description={t('fe_es_vehicle_page:liability_insurance')}
                >
                  <Box mt={1.5}>
                    <LightBulbHint>{t('fe_es_vehicle_page:owner_insurance_note')}</LightBulbHint>
                  </Box>
                </TextBox>
              </Box>
            )}
          </>
        )}

        {/* Location/Map - ALWAYS VISIBLE */}
        <Box mb={2.5}>
          {showMap ? (
            <Map
              circleLoaction={circleLoaction}
              center={{
                lat: +location.lat,
                lng: +location.lng,
              }}
              defaultZoom={15}
            />
          ) : (
            <Box style={{ height: 400 }} display="flex" alignItems="center" justifyContent="center">
              <Button onClick={handleShowMapClick}>show map</Button>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};

export default withTranslation('fe_es_vehicle_page')(VehiclePageQuote);